import { Component, inject, OnDestroy } from '@angular/core';
import { from, Subject, switchMap } from 'rxjs';
import { Router } from '@angular/router';
import { TermsAndConditionsService } from './service/terms-and-conditions.service';
import { WEBSITE_PROD_ORCA_PRIVACY_POLICY, WEBSITE_PROD_ORCA_TERMS_OF_USE } from "../../../util/common/links";
import { FRONT_URLS } from "../../../util/common/url-parts";
import { catchError, takeUntil } from "rxjs/operators";
import { CheckboxComponent } from "../../../domain/shared/component/checkbox/checkbox.component";
import { ButtonComponent } from "../../../domain/shared/component/buttons/button.component";

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss', '../../../domain/login/entrance-group.scss'],
  standalone: true,
  imports: [
    CheckboxComponent,
    ButtonComponent,
  ],
})
export class TermsAndConditionsComponent implements OnDestroy {
  private router = inject(Router);
  private termsAndConditionService = inject(TermsAndConditionsService);
  private _destroyStream: Subject<void> = new Subject<void>();

  isUserAgreed = false;

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  toggleIsUserAgreed(): void {
    this.isUserAgreed = !this.isUserAgreed;
  }

  submit(): void {
    this.termsAndConditionService
      .setAgreement(this.isUserAgreed)
      .pipe(
        switchMap(() => from(this.router.navigate([FRONT_URLS.ENTRANCE]))),
        catchError(() => from(this.router.navigate([FRONT_URLS.LOGIN]))),
        takeUntil(this._destroyStream),
      )
      .subscribe();
  }

  redirectTerms(): void {
    window.open(WEBSITE_PROD_ORCA_TERMS_OF_USE, '_blank');
  }

  redirectPolicy(): void {
    window.open(WEBSITE_PROD_ORCA_PRIVACY_POLICY, '_blank');
  }
}
